import LegalPage from "@/components/feature/LegalPage";
import { HERO_IMAGES } from "@/config/heroImages";

export default function PrivacyPage() {
  return (
    <LegalPage
      crumb="Privacy Policy"
      image={HERO_IMAGES.privacy}
      title="Privacy Policy"
      updated="1 January 2026"
      intro="Lahari Packers and Movers respects your privacy. This policy explains what information we collect when you enquire or book a move, how we use it and the choices you have."
      blocks={[
        {
          heading: "Information we collect",
          paragraphs: [
            "We collect only the details required to quote and complete your move. This typically includes your name, phone number, email address, pickup and delivery address, and a short description of the goods to be moved.",
            "If you book storage, we also record an item-wise inventory of your belongings so that your goods can be retrieved and delivered accurately.",
          ],
          list: [
            "Name and contact details",
            "Pickup and delivery addresses",
            "Move details and preferred dates",
            "Storage inventory, where applicable",
            "Communication history with our team",
          ],
        },
        {
          heading: "How we use your information",
          paragraphs: [
            "Your information is used to prepare estimates, plan your move, assign crews and vehicles, share delivery updates and provide after-move support.",
            "We may also use your contact details to send you service related updates or, if you have opted in, occasional offers about our moving and storage services.",
          ],
        },
        {
          heading: "Sharing with our team and partners",
          paragraphs: [
            "Your details are shared only with the Lahari staff and partners directly involved in executing your move, such as the assigned coordinator, packing crew and driver.",
            "We do not sell your personal information to third parties. Information is disclosed to authorities only where required by law.",
          ],
        },
        {
          heading: "Data retention",
          paragraphs: [
            "Move records, invoices and storage inventory sheets are retained for as long as required for accounting, warranty and legal purposes. Information that is no longer needed is securely removed from our active records.",
          ],
        },
        {
          heading: "Cookies and website data",
          paragraphs: [
            "Our website may use basic cookies or similar technologies to remember your preferences and understand how visitors use the site. These are used only to improve your experience and are not used to profile you personally.",
          ],
        },
        {
          heading: "Your choices and rights",
          paragraphs: [
            "You may request access to, correction of, or deletion of the personal information we hold about you by contacting our team. You can also opt out of promotional communication at any time.",
          ],
          list: [
            "Request a copy of your data",
            "Correct inaccurate details",
            "Ask us to delete your enquiry record",
            "Opt out of promotional messages",
          ],
        },
        {
          heading: "Contact us about privacy",
          paragraphs: [
            "For any question about this policy or how your information is handled, contact Lahari Packers and Movers, Bengaluru, using the phone number or email address listed on this page.",
          ],
        },
      ]}
    />
  );
}